import * as React from 'react';

import { formatTime } from '../../helpers/date';

interface LiveChatAgentTransferInitiateMessageProps {
	timestamp: number;
}

export const LiveChatAgentTransferInitiateMessage: React.FC<LiveChatAgentTransferInitiateMessageProps> = ({
	timestamp,
}) => {
	return (
		<div
			data-testid="live-chat-auto-disconnection-notice"
			className="flex items-center justify-center mx-2 mb-2 text-center"
		>
			<div className="text-body-sm bg-gray-30 px-3 py-1 rounded-md">
				<div className="text-xs">{formatTime(timestamp)}</div>
				Transferring to a new agent
			</div>
		</div>
	);
};

export default LiveChatAgentTransferInitiateMessage;
